import { Component, AfterViewInit } from '@angular/core';
import { DmarService } from 'app/services/dmar.service';
@Component({
  selector: 'flex-banner',
  templateUrl: './flex-banner.component.html'
})
export class FlexBannerComponent implements AfterViewInit {


  constructor(public dmarService: DmarService) { }
  isAdEnabled: Boolean;
  ngAfterViewInit() {
  setTimeout(() => {
  //	this.isAdEnabled=this.dmarService.isAdBlockerEnabled();   

    if(this.dmarService.isAdBlocking == true){
      console.log("Ad enabled");
    }
    
    });
  }

}